import { useParams } from "react-router-dom";
import { ContactDetails } from "@/features/person/components/ContactDetails";
import { CardGridSkeleton } from "@/components/Skeleton";
import ErrorBoundary from "@/components/ErrorBoundary";
import { usePersonContactDetailsQuery } from "./_usePersonContactDetailsQuery";

export default function PersonContact() {
  const { pgaId } = useParams();
  const { loaded, canViewPersonContact, person, error } = usePersonContactDetailsQuery(pgaId);

  if (!loaded || !canViewPersonContact) {
    return null;
  }

  if (error) {
    return (
      <ErrorBoundary
        variant="inline"
        title="Failed to Load Contact Details"
        message={error.message}
        className="mt-12"
      />
    );
  }

  if (!person) {
    return <CardGridSkeleton />;
  }

  return (
    <div>
      <ContactDetails person={person} />
    </div>
  );
}
